import Vue from 'vue'
import Vuex from 'vuex'
import _ from "lodash";
import axios from "axios";
import { detallePreinscripcion } from "../api";

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    inscripciones: [],
    valida: false,
    inscripcion: "",
    slugInscripcion: "",
    slugId:"",
    municipioIdStore:null,
    tipoVinStore:"",
    nivelStore:"",
    areaStore:"",
    sedeStore:"",
    experienciaStore:"",
    sedesStore:[],
    nombreEquipoStore:null,
    horariosStore:[],
    datosactualizar:[],
    cedula: "",
    fecha_nacimiento: "",
    debeActualizar: false,
    cargandoRuta: false,
    participante:"",

  },
  mutations: {
    setInscripciones(state, inscripciones) {
      state.inscripciones = inscripciones;
    },
    setTipoVin(state, tipoVin) {
      state.tipoVinStore = tipoVin;
    },
    setNivel(state, nivel) {
      state.nivelStore = nivel;
    },
    setArea(state, area) {
      state.areaStore = area;
    },
    setSede(state, sede) {
      state.sedeStore = sede;
    },
    setExpe(state, expe) {
      state.experienciaStore = expe;
    },
    setNombreEquipo(state, equipo) {
      state.nombreEquipoStore = equipo;
    },
    setMunicipio(state, municipio) {
      state.municipioIdStore = municipio;
    },
    setHorarios(state, horarios) {
      state.horariosStore = horarios;
    },
    salir(state) {
      state.inscripciones = []
      state.valida = false
      state.inscripcion = null
      state.slugInscripcion =  null
      state.slugId = null
      state.municipioIdStore = null
      state.tipoVinStore = null
      state.nivelStore = null
      state.areaStore = null
      state.sedeStore = null
      state.experienciaStore = null
      state.sedesStore = []
      state.nombreEquipoStore = null
      state.horarios=null
      state.horariosStore=[]
      state.cedula = null
      state.debeActualizar = false
      state.cargandoRuta = false
      state.participante = null
    },
    validar(state, { cedula, debeActualizar }) {
      state.valida = true;
      state.cedula = cedula;
      state.debeActualizar = debeActualizar;
    },
    setDatosAct(state, datos) {
      state.datosactualizar = datos;
    },
    setCargandoRuta(state, val) {
      state.cargandoRuta = val;
    },
    setPaticipanteAct(state, participante){
      state.participante = participante
    },
    setCedula(state, cedula){
      state.cedula = cedula
    }
  },
  actions: {
    fetchInscripciones: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(detallePreinscripcion)
          .then(res => {
            console.log(res);
            commit("setInscripciones", res.data.results);
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            console.error(err.response);
            reject(err);
          });
      });
    },
    setValidar: ({ commit }, datos) => {
      commit("validar", datos);
    },
    setCargandoRuta: ({ commit }, val) => {
      commit("setCargandoRuta", val);
    },
  
    
  },
  getters: {
    
    getDatosAct: state => {
      return state.datosactualizar;
    },
    getEstrategias: state => {
      return state.inscripciones.filter(e=>e.activo);
    },
    getEstrategia: (state, getters) => {
      return _.find(getters.getEstrategias, { 'slug': getters.estrategia });
    },
    estrategia: state => {
      return state.inscripcion;
    },
    getSlugRegex: (state, getters) => {
      let inscripciones = _.map(getters.getInscripciones, "slug");
      return `(${inscripciones.join("|")})`;
    },
    getInscripciones: state => {
      return state.inscripciones.filter(e=>e.activo);
    },
    valida: state => {
      return state.valida;
    },
  },

  modules: {
  }
})
